// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { List } from 'immutable'

// returns an immutable List of the segment end summaries
// which were selected for Bulk Update.

const getSelectedSegmentEnds = () => (dispatch, getState) => {
  const { bulkEdit } = getState()

  const highlightedSiteIds = bulkEdit.get('highlightedSiteIds')

  return bulkEdit.get('bulkEditPaths').reduce((a, d) => {
    const sitesToAdd = []

    const site1 = d.get('site1')
    const site2 = d.get('site2')

    if (highlightedSiteIds.includes(site1.get('segmentEndId'))) {
      sitesToAdd.push(site1)
    }

    if (highlightedSiteIds.includes(site2.get('segmentEndId'))) {
      sitesToAdd.push(site2)
    }

    return a.push(...sitesToAdd)
  }, List())
}

export default getSelectedSegmentEnds
